/// <amd-module name="Dashboards/WidgetHost/OverlayComponents/WidgetHostEditOverlay" />
import * as Resources from "Dashboards/WidgetHost/Resources";
import React = require("react");
import { css, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";

/**
 * WidgetHost Overlay is a shallow control, which passes simple non-contextual events up to the Widget Host(in dashboard-edit mode), which exposes proper events for consumers.
 */
export interface WidgetHostEditOverlayProps extends IVssComponentProperties {
    // Configure is responsibility of Experience
    onConfigureWidget: () => void;
    // Delete is responsibility of Experience
    onDeleteWidget: () => void;

    // Indicates if this Widget type allows for configuration
    canConfigureWidget: boolean;

    // Event to raise on key down
    onKeyDown: (event: React.KeyboardEvent, isFirstButton: boolean) => void;
}

/**
 * Responsible for rendering Edit-mode overlay experience.
 */
export class WidgetHostEditOverlay extends VssComponent<WidgetHostEditOverlayProps> {
    private _closeRef: Button | null;
    private _configRef: Button | null;

    public render(): JSX.Element {
        return (
            <div className="widget-host-edit-overlay interaction-overlay">
                <div className={css("widget-host-edit-row", "inline-flex-row")}>
                    {this.props.canConfigureWidget && (
                        <Button
                            subtle
                            className="configure-widget-button"
                            iconProps={{ iconName: "Settings" }}
                            onClick={this.props.onConfigureWidget}
                            ariaLabel={Resources.ConfigureWidgetText}
                            ref={(ref) => this._configRef = ref}
                            onKeyDown={(event) => this.props.onKeyDown(event, this.props.canConfigureWidget) }
                        />
                    )}
                    {
                        <Button
                            subtle
                            className="delete-widget-button"
                            iconProps={{ iconName: "Cancel" }}
                            onClick={this.props.onDeleteWidget}
                            ariaLabel={Resources.DeleteWidgetText}
                            ref={(ref) => this._closeRef = ref}
                            onKeyDown={(event) => { this.props.onKeyDown(event, !this.props.canConfigureWidget) }}
                        />
                    }
                </div>
            </div>
        );
    }

    public focus() {
        if (this._configRef) {
            this._configRef.focus();
        }
        else if (this._closeRef) {
            this._closeRef.focus();
        }
    }
}

